import { compose } from 'recompose'

import withTranslation from '../../../globals/components/withTranslation'
import withPermissions from '../../../globals/components/withPermissions'

import Component from './component'

export default compose(withTranslation, withPermissions)(Component)
